import React from 'react';
import { PageStateManager } from './page-state-manager';

type PageContextType = {
  pageStateManager: PageStateManager;
};

const PageContext = React.createContext<PageContextType>({
  pageStateManager: new PageStateManager(),
});
export default PageContext;
